import "./BookListPublic.scss";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getBooks, getMoreBooks, getBooksByCategory, getMoreBooksByCategory } from "../../../redux/actions/book"
import Button from "../../DesingSystem/Button/Button";
import {types} from "../../../constants/constants";
import BookItemPublic from "../BookItemPublic/BookItemPublic";
import ModalBookDetail from "../../BookCatalog/ModalBookDetail/ModalBookDetail";
import { getApiBookBySlug } from "../../../services/apiBook";


function BookListPublic(props) {
  const urlParams = useParams()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const books = useSelector((store) => store.book.books);
  const totalBooks = useSelector((store) => store.book.total);
  const [bookSlug, setBookSlug] = useState(null);
  const [limit, setLimit] = useState(types.PAGE_SIZE);
  const [offset, setOffset] = useState(0);
  const [modalDetailSingleShow, setModalDetailSingleShow] = useState(true);

  useEffect(() => {
    const slug = urlParams.slug
    if(slug){
      const results = getApiBookBySlug(slug)
      .then(async (response) => {
        setBookSlug(response)
      })
      .catch((error) => {
        console.log(error.message);
        setBookSlug(null)
      });
    }
  }, []);

  useEffect(() => {
    if(props.category != '' && typeof props.category !== 'undefined'){
      dispatch(getBooksByCategory({ limit: limit, offset: offset, sortDirection: -1, slug : urlParams.slug }))
    }else{
      dispatch(getBooks({ limit: limit, offset: offset, sortDirection: -1 }))
    }
  }, [dispatch]);


  const renderBooks = () => {
    return books.map((book, bookIndex) => {
      return <BookItemPublic book={book} key={book._id} index={bookIndex} />;
    });
  };

  const loadMoreResults = () => {
    const offsetPage = offset + limit;
    setOffset(offsetPage);
    
    if(props.category != '' && typeof props.category !== 'undefined'){
      dispatch(getMoreBooksByCategory({ limit: limit, offset: offset, sortDirection: -1, slug : urlParams.slug }))
    }else{
      dispatch(getMoreBooks({ limit: limit, offset: offsetPage, sortDirection: -1 }))
    }
  }

  const hideModalDetailSingle = (e) => {
    e && e.stopPropagation();
    setModalDetailSingleShow(false);
  };

  return books ? (
    <div>
      <ul className="book-list-public">{renderBooks()}</ul>
      
      <div className="book-list-public__container-button">
        { totalBooks > books.length ?
          <Button className={'btn-white big'} text={'Cargar más títulos'} onClick={ () => { loadMoreResults() } } />
          : null }
      </div>  
      <div className="book-list-public__container-button-mobile">
        { totalBooks > books.length ?
          <Button className={'btn-blackbg'} text={'Ver más'} onClick={ () => { loadMoreResults() } } />
          : null }
      </div> 

      <React.Fragment>
        {bookSlug ? (
          <ModalBookDetail
            book={bookSlug}
            show={modalDetailSingleShow}
            hide={hideModalDetailSingle}
          />
        ) : null}
      </React.Fragment>    
    </div>
  ) : (
    
    <div className="row ">
      <div className="col">
        <p className="ms-5">No hay libros publicados</p>      
      </div>
    </div>
  );
}

export default BookListPublic;
